import { CompoundEntityRef } from '@backstage/catalog-model';
import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import {
  ApiDocsEnvironmentsApi,
  ApiEnvironmentDefinition,
  ApiEnvironments,
} from './ApiDocsEnvironmentsApi';

export class ApiDocsEnvironmentsClient implements ApiDocsEnvironmentsApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getEnvironments(api: CompoundEntityRef): Promise<ApiEnvironments> {
    return this.get(`${this.apiPath(api)}/environments`);
  }

  async getDefinition(
    api: CompoundEntityRef,
    environment: string,
  ): Promise<ApiEnvironmentDefinition> {
    return this.get(
      `${this.apiPath(api)}/environments/${encodeURIComponent(
        environment,
      )}/definition`,
    );
  }

  private apiPath({ namespace, name }: CompoundEntityRef): string {
    return `/apis/${encodeURIComponent(namespace)}/${encodeURIComponent(name)}`;
  }

  private async get<T>(path: string): Promise<T> {
    const baseUrl = await this.discoveryApi.getBaseUrl('api-docs-environments');
    const response = await this.fetchApi.fetch(`${baseUrl}${path}`);
    if (!response.ok) {
      // Carries the backend's message, e.g. why a template was rejected.
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
}
